import { clsx } from 'clsx'
import { ActionButton, Base, CheckIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { useRestock } from '@/hooks'
import { RestockItem } from '@/domain/restock'

interface RestockActionBarProps {
  processId: string
  ecommerceId: string
  restocks: RestockItem[]
  handleClickCancel: () => void
}

export const RestockActionBar: React.FC<RestockActionBarProps> = ({
  processId,
  ecommerceId,
  restocks,
  handleClickCancel
}) => {
  const { t } = useTranslation()

  const {
    mutate: restockItems,
    isPending: loadingRestock,
    isSuccess: restockSuccess
  } = useRestock()

  const disableSubmit = !restocks.some((r) => r.status === 'SHOULD_RESTOCK')

  const handleClickSubmit = () => {
    if (!processId || !ecommerceId || loadingRestock || restockSuccess) return
    restockItems({ processId, ecommerceId, items: restocks })
  }

  return (
    <div
      className={clsx(
        'absolute bottom-0 w-full bg-white p-4',
        'border-t border-solid border-[#E1E4EAFF]',
        'flex items-center justify-end gap-2'
      )}
    >
      <ActionButton variant="outlined" onClick={handleClickCancel}>
        <p className="text-sm">{t('products_tab.cancel')}</p>
      </ActionButton>
      <ActionButton
        className="min-w-[110px]"
        onClick={handleClickSubmit}
        disabled={disableSubmit}
      >
        {loadingRestock ? (
          <Base.Spinner
            variant="dots"
            label={t('process_details_page.restocking')}
          />
        ) : restockSuccess ? (
          <CheckIcon />
        ) : (
          <p className="text-sm">{t('process_details_page.restock')}</p>
        )}
      </ActionButton>
    </div>
  )
}
